// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductList_container__33vE9","filter":"ProductList_filter__2_fZi"};